import React from 'react';

import {FormItemSkeleton, FormSectionSkeleton, SkeletonItem} from 'src/components/skeleton';

import {Group} from '@pb/kit-component-group';


export const EmailSetupSkeleton = () => (
    <FormSectionSkeleton labelWidth={200}>
        <Group direction="v" alignItems="start">
            <FormItemSkeleton labelWidth={100}>
                <SkeletonItem width={300} height={30}/>
            </FormItemSkeleton>
            <SkeletonItem width={600} height={100}/>
        </Group>
    </FormSectionSkeleton>
);
